module.exports = __webpack_public_path__ + "static/Axiforma-Bold-9594db2ff92b1099fe032a8a187c81c4.woff";